import styled from 'styled-components'

export const Submit = styled.input`
  height: 4rem;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`
